<template>
  <app-page
    :title="
      employee
        ? $t('employee.resetPassword.title', { name: employee.full_name })
        : $t('employee.resetPassword.titleFallback')
    "
    :previous="[
      { label: $t('employee.previousLabel'), to: { name: 'employees' } },
      {
        label: employee ? employee.full_name : $t('employee.title'),
        to: { name: 'employee', params: { employeeId: $route.params.employeeId } },
      },
    ]"
    :error="error"
    icon="lock-open"
  >
    <app-loading :loading="loading" />
    <template v-if="!loading && !saved">
      <sme-alert level="warning" class="mb-3">
        {{ $t('employee.resetPassword.recommendBody') }}
        <br />
        {{ $t('employee.resetPassword.emailLinkBody') }}
      </sme-alert>

      <ValidationObserver v-slot="v">
        <b-form @submit.prevent="v.handleSubmit(onSubmit)">
          <app-input
            v-model="reason"
            type="text"
            name="reason"
            rules="required"
            :label="$t('employee.resetPassword.reasonLabel')"
            :disabled="saving || saved"
            :validate-immediate="false"
          ></app-input>
          <page-sub-footer>
            <b-button
              data-testid="reset-password-button"
              type="submit"
              variant="primary"
              :disabled="v.invalid || saving || saved"
            >
              <b-spinner v-if="saving" class="mr-2" small />
              {{ saving ? $t('employee.resetPassword.submittingButton') : $t('employee.resetPassword.submitButton') }}
            </b-button>
          </page-sub-footer>
        </b-form>
      </ValidationObserver>
    </template>
    <sme-alert v-if="saved" level="good">
      {{ $t('employee.resetPassword.successAlert', { name: employee.full_name }) }}
    </sme-alert>
  </app-page>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import ApiClient from '@/ApiClient';
import AppInput from '@/components/AppInput.vue';
import AppLoading from '@/components/AppLoading.vue';
import AppPage from '@/components/AppPage.vue';
import PageSubFooter from '@/components/PageSubFooter.vue';
import SmeAlert from '@/components/atoms/SmeAlert.vue';
import State from '@/state/State';

export default {
  name: 'EmployeeResetPassword',
  components: { ValidationObserver, AppInput, AppLoading, AppPage, PageSubFooter, SmeAlert },
  data() {
    return {
      loading: true,
      saving: false,
      saved: false,
      error: undefined,
      employee: undefined,
      state: State.state,
      reason: undefined,
    };
  },
  methods: {
    onSubmit() {
      this.saving = true;

      ApiClient.employeeResetPassword(
        this.employee.employee_id,
        this.reason,
        this.state.user.user_id,
        this.employee.work_email,
      ).then(
        () => {
          this.saving = false;
          this.saved = true;
        },
        error => {
          this.error = error.message;
          this.loading = false;
        },
      );
    },
    loadData() {
      this.loading = true;
      ApiClient.getEmployee(this.$route.params.employeeId).then(
        employee => {
          this.employee = employee;
          this.loading = false;
        },
        error => {
          this.error = error.message;
          this.loading = false;
        },
      );
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
